import { createFileRoute } from "@tanstack/react-router";
import CustomPage from "@/pages/CustomPage";
import { pageHead } from "@/lib/routeHead";

const DEFAULT_DESC = "Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.";

export const Route = createFileRoute("/p/$slug")({
  // Fetch the page's own SEO title/description so campaign landing pages rank on their content.
  loader: async ({ params }) => {
    try {
      const { getSupabase } = await import("@/integrations/supabase/lazy");
      const supabase = await getSupabase();
      const { data } = await supabase
        .from("custom_pages")
        .select("title, meta_title, meta_description, hero_image_desktop")
        .eq("slug", params.slug)
        .eq("is_published", true)
        .maybeSingle();
      return { seo: data ?? null };
    } catch {
      return { seo: null };
    }
  },
  head: ({ params, loaderData }) => {
    const s = loaderData?.seo;
    const img = s?.hero_image_desktop && /^https:\/\//.test(s.hero_image_desktop) ? s.hero_image_desktop : undefined;
    return pageHead({
      title: s?.meta_title || s?.title || "Rex & Sons RVs",
      description: s?.meta_description || DEFAULT_DESC,
      path: `/p/${params.slug}`,
      ...(img ? { image: img } : {}),
    });
  },
  component: CustomPage,
});
